import React, { memo } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { FromJsonTypeMapping, QuestionType } from './questions';
import { CheckboxIcon, DropdownIcon, TextIcon, ToggleIcon } from './questions/icons';

import './checklist-overview.css';

const QuestionTypeIcons = {
    [QuestionType.DROPDOWN]: <DropdownIcon />,
    [QuestionType.MULTIPLE_CHOICE]: <CheckboxIcon />,
    [QuestionType.TEXT]: <TextIcon />,
    [QuestionType.TOGGLE]: <ToggleIcon />,
};

function ChecklistOverviewComponent({ checklist }) {
    const structure = JSON.parse(checklist.json);

    return (
        <Card className={ 'checklist-overview' }>
            <CardHeader>
                { checklist.name }
            </CardHeader>
            <CardBody>
                <ul>
                    { structure.groups?.map((group, groupIndex) => (
                        <li
                            key={ `checklist-overview-${ checklist.id }-group-${ group.id }:${ groupIndex }` }
                            className={ 'checklist-element--group' }
                        >
                            { group.name }
                            <ul>
                                { group.questions?.map((question, questionIndex) => (
                                    <li
                                        key={ `checklist-overview-${ checklist.id }-group-${ group.id }:${ groupIndex }-question-${ question.id }:${ questionIndex }` }
                                        className={ 'checklist-element--question' }
                                    >
                                        <span className={ 'checklist-overview--question-icon' }>
                                            { QuestionTypeIcons[FromJsonTypeMapping[question.type]] }
                                        </span>
                                        { question.question }
                                    </li>
                                )) }
                            </ul>
                        </li>
                    )) }
                </ul>
            </CardBody>
        </Card>
    );
}

// Don't re-render the component unless we're giving it a different checklist.
export const ChecklistOverview = memo(ChecklistOverviewComponent, (a, b) => a.checklist.json === b.checklist.json);
